const financialPolicySnapshot = (user = {}) => {
  const policy = user.financialPolicy || {};
  return {
    platformCommissionRate: policy.platformCommissionRate ?? null,
    workerPayoutRate: policy.workerPayoutRate ?? null,
    partnerCommissionShareRate: policy.partnerCommissionShareRate ?? user.partner?.commissionShareRate ?? null,
    partnerCommissionRate: policy.partnerCommissionRate ?? null,
    platformNetCommissionRate: policy.platformNetCommissionRate ?? null,
  };
};

const jobCommissionRateSnapshot = (job = {}) => job.commissionRate ?? null;
const jobWorkerPayoutRateSnapshot = (job = {}) => job.workerPayoutRate ?? null;
const currentCommissionLabel = (rate) => {
  if (rate == null || !Number.isFinite(Number(rate))) return 'Não informado';
  return `${Number((Number(rate) * 100).toFixed(2)).toLocaleString('pt-BR')}%`;
};

export { financialPolicySnapshot, jobCommissionRateSnapshot, jobWorkerPayoutRateSnapshot, currentCommissionLabel };
